<template>
  <panel
    :breadcrumbs="breadcrumbs"
    :title="reportTitle"
  >
    <v-card v-if="masterDealer">
      <v-alert
        type="info"
        color="green darken-2"
        :value="true"
        class="mb-4"
        outline
      >
        - ONEXOX Prepaid activation with RM30 topup only will be counted.
        <br>
        - All the activation must be in ACTIVE status at the end of the month.
        <br>
        - Different numbers registered using one IC/ Passport will only be counted as 1 activation (except MNP).
        <br>
        - This incentive does not count (break away) the number of activations made by other MD under their network.
      </v-alert>
    </v-card>
    <v-card v-if="areaDealer">
      <v-alert
        type="info"
        color="green darken-2"
        :value="true"
        class="mb-4"
        outline
      >
        - ONEXOX Prepaid activation with RM30 topup only will be counted.
        <br>
        - All the activation must be in ACTIVE status at the end of the month.
        <br>
        - Different numbers registered using one IC/ Passport will only be counted as 1 activation (except MNP).
        <br>
        - This incentive does not count (break away) the number of activations made by other AD under their network.
      </v-alert>
    </v-card>
    <v-card>
      <v-toolbar
        dense
        card
      >
        <v-menu
          v-model="menu"
          close-on-content-click
          transition="scale-transition"
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="monthOf"
            prepend-icon="event"
            readonly
          />
          <v-date-picker
            v-model="monthOf"
            :max="maxDate"
            :allowed-dates="allowedMonths"
            min="2025-04"
            type="month"
            year-icon="date_range"
          />
        </v-menu>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-xs>
          <v-layout
            row
            wrap
          >
            <v-flex xs10>
              <v-layout
                row
                wrap
              >
                <template v-for="field in self">
                  <v-flex
                    :key="field.name"
                    xs6
                  >
                    <span class="primary--text">{{ field.name }}</span>
                  </v-flex>
                  <v-flex
                    :key="field.name + 'value'"
                    xs4
                  >
                    {{ field.value }}
                  </v-flex>
                </template>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider />
    </v-card>
    <v-card>
      <!-- <v-card-title>Royalty Incentive (Ri)</v-card-title> -->
      <v-toolbar
        dense
        dark
      >
        <v-toolbar-title>Royalty Incentive (Ri)</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="royaltyIncentive"
        :loading="loading"
        :search="search"
        class="px-1 pb-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left">
              {{ props.item.target }}
            </td>
            <td class="text-xs-center">
              {{ props.item.tier }}
            </td>
            <td class="text-xs-center">
              <v-icon
                v-if="props.item.entitlement === true "
                color="success"
              >
                mdi-check
              </v-icon>
              <v-icon
                v-else-if="props.item.entitlement === false "
                color="error"
              >
                mdi-close
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider />
      <!-- <v-card-title>Prepaid Activation Incentive (Ai)</v-card-title> -->
      <v-toolbar
        dense
        dark
      >
        <v-toolbar-title>Prepaid Activation Incentive (Ai)</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers2"
        :items="prepaidIncentive"
        :loading="loading"
        :search="search"
        class="px-1 pb-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left">
              {{ props.item.total }}
            </td>
            <td class="text-xs-center">
              {{ props.item.dealerRecruit }}
            </td>
            <td class="text-xs-center">
              {{ props.item.incentive }}
            </td>
            <td class="text-xs-center">
              {{ props.item.total_incentive }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </panel>
</template>

<script>
import { DateTime, Interval } from 'luxon'
import { createGetParams } from '@/rest'
import security from '@/security'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "Panel" */ '@/components/Panel'),
  },
  data () {
    return {
      headers: [
        {
          align: 'left',
          sortable: false,
          text: 'Target',
          value: 'target',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Tier Entitled',
          value: 'tier',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Entitlement',
          value: 'entitlement',
        },
      ],
      headers2: [
        {
          align: 'left',
          sortable: false,
          text: 'Total Prepaid Group Activation',
          value: 'total',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Dealer Recruitment',
          value: 'dealerRecruit',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Incentive (RM)',
          value: 'incentive',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Total Incentive  (RM)',
          value: 'total_incentive',
        },
      ],
      royaltyIncentive: [],
      prepaidIncentive: [],
      loading: false,
      maxDate: '',
      menu: false,
      monthOf: null,
      noDataText: "There's nothing to display.",
      noResultText: 'No data that fits that criteria.',
      pagination: {
        descending: true,
        sortBy: 'dealer',
      },
      paginationAd: {
        descending: true,
        sortBy: 'dealer',
      },
      search: '',
      self: null,
      title: this.reportTitle,
    }
  },

  computed: {
    areaDealer: function () {
      return security.me.dealerRank() === 'Area Dealer'
    },
    masterDealer: function () {
      return security.me.dealerRank() === 'Master Dealer'
    },

    reportTitle () {
      const rank = security.me.dealerRank()
      let prefix = ''

      if (rank === 'Master Dealer') prefix = 'MD'
      else if (rank === 'Area Dealer') prefix = 'AD'
      else prefix = rank || ''

      return `${prefix} Prepaid Activation Incentive`
    },
    breadcrumbs () {
      return [
        {
          text: 'Group Incentive',
          disabled: false,
          to: '/GroupIncentive',
        },
        {
          text: this.reportTitle,
          disabled: true,
        },
      ]
    },
  },

  watch: {
    monthOf: function (val) {
      this.getPerformance(val)
    },
  },
  mounted: function () {
    const now = DateTime.local().setZone('Asia/Kuala_Lumpur')
    this.maxDate = this.monthOf = now.toFormat('yyyy-LL')
  },
  methods: {
    allowedMonths: function (month) {
      const ym = month.split('-')
      const whatMonth = DateTime.local(Number(ym[0]), Number(ym[1])).setZone('Asia/Kuala_Lumpur')
      const fromDate = DateTime.local(2018, 1, 1).setZone('Asia/Kuala_Lumpur')
      const now = DateTime.local().setZone('Asia/Kuala_Lumpur')

      return Interval.fromDateTimes(fromDate, now).contains(whatMonth)
    },
    getPerformance (month) {
      this.loading = true
      const params = createGetParams({
        month: month,
      })
      this.loading = true
      this.royaltyIncentive = []
      this.prepaidIncentive = []
      this.$rest.get('getMdGroupPrepaidAI.php', params)
        .then(function (response) {
          this.self = response.data.self
          this.royaltyIncentive = response.data.royaltyIncentive
          this.prepaidIncentive = response.data.prepaidIncentive
          this.loading = false
        }.bind(this)).catch(error => {
          this.noDataText = error.message
          this.loading = false
        })
    },
  },
}
</script>

  <style>
  .custom-header {
    background-color: #1976D2; /* Example blue background */
    color: white;
  }
  </style>
